import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import TextEditor from "../../../text-editor/TextEditor";
import { SortableList } from "../../../SortableList";
import { Button, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useAddLesson } from "../../../../stores/stores";
import { initialChooseShortTextQuestionValue, ModeQuestion } from "../../../../constants";
import { QuestionAnswerInfo, QuestionData, QuestionItemDetail, } from "../../../../types/course-construction";
import { findMaxIndexOfArray, mapAnsBEtoFE } from "../../../../utils/arrays";
import { renderQuestionNameByType, renderQuestionDescriptionByType } from "../../../../utils/functionUltils";
import QuestionEssayItem from "./QuestionEssayItem";
import { useDirty } from "../../../../contexts/DirtyProvider";

function Essay({ data = {} as QuestionData, defaultName }: QuestionItemDetail) {
  const { t } = useTranslation();
  const question = useAddLesson((state: any) => state.question);
  const [questionName, setQuestionName] = useState<string>();
  const [answers, setAnswers] = useState(initialChooseShortTextQuestionValue);
  const modeQuestion = useAddLesson((state) => state.modeQuestion);

  const setCurrentQuestionInfo = useAddLesson(
    (state) => state.setCurrentQuestionInfo
  );

  const { setDirty } = useDirty();

  const handleChangeText = (current: { id: number; value: string }) => {
    const distAnswer = [...answers];
    const indexOfChangeItem = distAnswer.findIndex(
      (item: QuestionAnswerInfo) => item.id === current.id
    );
    if (indexOfChangeItem !== -1) {
      distAnswer[indexOfChangeItem] = {
        ...distAnswer[indexOfChangeItem],
        value: current.value,
      };
      setAnswers(distAnswer);
    }
  };

  const handleRemoveOneChoose = (id: number) => {
    if (id) {
      const newList = [...answers];
      setAnswers(newList.filter((item: QuestionAnswerInfo) => item.id !== id));
    } else console.error("Cannot find id");
  };

  const handleAddMoreChoose = () => {
    if (answers.length > 0) {
      const newItem = {
        id: findMaxIndexOfArray(answers) + 1,
        value: "",
        key: findMaxIndexOfArray(answers) + 1,
        isTrue: true,
        point: 0,
      };
      const newList = [...answers];
      setAnswers(newList.concat([newItem]));
    } else setAnswers(initialChooseShortTextQuestionValue)
    setDirty(true);
  };

  useEffect(() => {
    setCurrentQuestionInfo({ ...answers, questionName: questionName, });
  }, [answers, questionName]);


  useEffect(() => {
    setQuestionName(question.question);
    if (modeQuestion === ModeQuestion.UPDATE && data.answers && data.answers?.length > 0) {
      const feAnswer = mapAnsBEtoFE(data.answers);
      setAnswers(feAnswer);
    } else {
      setAnswers([]);
    }
  }, [question, data.answers, modeQuestion]);

  const handleChangeQuestionName = (qName: string) => {
    setQuestionName(qName);
  };

  const handleDragChange = (value: any) => {
    setAnswers(value);
    setDirty(true);
  };

  const handleChangeChecked = (checked: boolean, id: number) => {
    const newList = [...answers];
    newList.forEach((item: QuestionAnswerInfo) => {
      if (item.id === id) item.isTrue = checked;
    });
    setAnswers(newList);
  };

  return (
    <section className='question-wrapper'>
      <Typography.Title level={5} className="question-title">
        {renderQuestionNameByType(question.type)}
      </Typography.Title>
      <Typography.Title level={1} className="question-description secondary-color">
        {renderQuestionDescriptionByType(question.type)}
      </Typography.Title>
      <TextEditor value={questionName || defaultName} onChange={handleChangeQuestionName} />
      <div className="tree-course-construct list-answers choose-text">
        <SortableList
          items={answers}
          onChange={handleDragChange}
          renderItem={(record: any) => (
            <SortableList.Item id={record.id}>
              <SortableList.DragHandle />
              <QuestionEssayItem
                index={record.id}
                value={record.value}
                onChangeChecked={(checked: boolean) =>
                  handleChangeChecked(checked, record.id)
                }
                onChange={handleChangeText}
                onDelete={handleRemoveOneChoose}
              />
            </SortableList.Item>
          )}
        />
        <Button
          icon={<PlusOutlined className="size-22" />}
          className="btn-add-more mt-2"
          onClick={handleAddMoreChoose}
        >
          {t("Thêm tiêu chí", "Thêm tiêu chí")}
        </Button>
      </div>
    </section>
  );
}

export default Essay;
